<template>
  <div class="row">
    <div class="col-12">
      <el-table :data="fanLogs">
        <el-table-column prop="id" label="팬로그ID" />
        <el-table-column :min-width="200" label="팬로그 내용">
          <div slot-scope="props">
            {{ props.row.contents.length > 20 ? props.row.contents.substring(0, 20) : props.row.contents }}
          </div>
        </el-table-column>
        <el-table-column label="컨텐트 작성자">
          <div slot-scope="props">
            <a href="javascript:void(0);" @click.stop="onClickUserId(props.row.userId)">{{ props.row.nickname }}</a>
          </div>
        </el-table-column>
        <el-table-column :formatter="(row) => $options.filters.formatDateTime(row.displayTime)" label="표시시간" />
        <el-table-column :min-width="60" align="center" label="액션">
          <div slot-scope="props">
            <base-button @click.native="onSharePage(props.row.idHash)" class="btn-link" type="info" size="sm"> 공유페이지 </base-button>
            <base-button @click.native="onDetailPage(props.row.id)" class="btn-link" type="danger" size="sm"> 상세페이지</base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages"></base-pagination>
    </div>
  </div>
</template>

<script>
import { BasePagination } from "@/components/index";
import Endpoints from "@/common/Endpoints";

export default {
  name: "FanLogTableView",
  components: {
    BasePagination,
  },
  async created() {
    await this.getFanLogs();
  },
  data() {
    return {
      totalPages: 1,
      fanLogs: [],
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getFanLogs(this.currentPage);
      },
    },
  },

  props: {
    scheduleId: {
      type: String,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    async getFanLogs(page) {
      const result = await this.$axios.get(`/schedule/${this.scheduleId}/fanLogs?page=${page ? page : 1}`);
      this.fanLogs = result.data.data.data;
      this.totalPages = Number(result.data.data.page);
    },
    onSharePage(idHash) {
      window.open(`${Endpoints.sharePageUrl}/f/${idHash}`);
    },
    onDetailPage(id) {
      this.$router.push(`/fanLog/fanLogDetail?fanLogId=${id}`);
    },
    onClickUserId(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
  },
};
</script>
<style lang="scss"></style>
